const Home = () => {
	return (
		<div className="bg-slate-950 text-secondary h-full flex flex-col items-center justify-center text-center">
			<h1 className="text-4xl font-bold">
				Welcome to ICEPyramid Communication Limited
			</h1>
			<p className="text-lg mt-4">Your trusted partner in IT solutions.</p>
			<button
				type="buttom"
				className="mt-10 bg-red-900 text-white px-6 py-3 rounded hover:bg-red-950"
			>
				Learn More
			</button>
		</div>
	);
};

export default Home;
